import { render, staticRenderFns } from "./UserToken.vue?vue&type=template&id=7ff1e1f0&"
import script from "./UserToken.vue?vue&type=script&lang=js&"
export * from "./UserToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports